export default __webpack_public_path__ + "static/media/pc_tablet.7ff4e33c.svg";